export default {
  '星期一': '星期一',
  '星期二': '星期二',
  '星期三': '星期三',
  '星期四': '星期四',
  '星期五': '星期五',
  '星期六': '星期六',
  '星期日': '星期日',
  '上午': '上午',
  '下午': '下午',
  '晚上': '晚上',
  '凌晨': '凌晨',
  '{nickname} {nowTimeCall}好，当前的时间为：{nowTime}': '{nickname} {nowTimeCall}好，当前的时间为：{nowTime}',
  '{year}年{month}月{day}日 {hour}:{minute}:{second} {week}': '{year}年{month}月{day}日 {hour}:{minute}:{second} {week}',
  '管理员': '管理员',
  '附件': '附件',
  '启用扩展': '启用扩展',
  '管理分组': '管理分组',
  '系统信息': '系统信息',
  '当前版本': '当前版本',
  '服务器域名/IP': '服务器域名/IP',
  '服务器信息': '服务器信息',
  '服务器环境': '服务器环境',
  'PHP 版本': 'PHP 版本',
  'MySQL 版本': 'MySQL 版本',
  '最大上传限制': '最大上传限制',
  '服务器时间': '服务器时间'
}
